module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_nagano-a0ce6f00311cc367f293c2b19c64ad32.png";